// data/prebuiltProfiles.ts
import { PrebuiltProfile } from '../types/studio.types';

// Pre-built co-host profiles
export const prebuiltCoHostProfiles: PrebuiltProfile[] = [
  {
    id: 'news-anchor',
    name: 'Professional News Anchor',
    description: 'A polished, authoritative news presenter with broadcast experience',
    coHostProfile: {
      name: 'Alex Reynolds',
      nickname: 'Alex',
      gender: 'non-binary',
      pronouns: 'they/them',
      age: '42',
      background: 'Experienced broadcast journalist with 15 years in television news. Known for clear delivery and thoughtful analysis of complex issues.',
      personalityTraits: 'Professional, authoritative, trustworthy, articulate, measured',
      speakingStyle: 'Clear, well-paced delivery with perfect pronunciation. Uses educated vocabulary without being pretentious. Natural emphasis on key points.',
      voiceType: 'castingDirector',
    }
  },
  {
    id: 'community-reporter',
    name: 'Local Community Reporter',
    description: 'A warm, approachable journalist deeply connected to local issues',
    coHostProfile: {
      name: 'Sarah Chen',
      nickname: 'Sarah',
      gender: 'female',
      pronouns: 'she/her',
      age: '35',
      background: 'Community journalist with strong roots in local reporting. Started in neighborhood newsletters and worked up to local papers. Passionate about amplifying community voices.',
      personalityTraits: 'Warm, empathetic, curious, accessible, community-oriented',
      speakingStyle: 'Conversational and relatable with a hint of enthusiasm. Uses inclusive language and occasionally includes colloquial phrases from the community.',
      voiceType: 'castingDirector',
    }
  },
  // Add more profiles here...
];

// Pre-built end-user profiles
export const prebuiltEndUserProfiles: PrebuiltProfile[] = [
  {
    id: 'busy-parent',
    name: 'Busy Parent',
    description: 'A parent with limited time who wants to stay informed about local events relevant to families',
    endUserProfile: {
      name: 'Jamie',
      interests: ['schools', 'family events', 'parks', 'child-friendly activities', 'education'],
      preferredContentTypes: ['community events', 'education news', 'safety updates'],
      location: 'CA#San Francisco',
      age: '38',
      gender: 'unspecified',
      conversationalInformality: 3,
    }
  },
  {
    id: 'young-professional',
    name: 'Young Professional',
    description: 'A career-focused individual interested in local business, arts, and nightlife',
    endUserProfile: {
      name: 'Taylor',
      interests: ['business', 'restaurants', 'arts', 'technology', 'networking events'],
      preferredContentTypes: ['business news', 'cultural events', 'technological innovations'],
      location: 'CA#San Francisco',
      age: '28',
      gender: 'unspecified',
      conversationalInformality: 3,
    },
  },
  {
    id: 'david-levine',
    name: 'David Levine',
    description: 'Location Station founder interested in local news and community events',
    endUserProfile: {
      name: 'David',
      interests: ['business', 'restaurants', 'arts', 'technology'],
      preferredContentTypes: ['business news', 'cultural events', 'technological innovations'],
      location: 'CA#San Francisco',
      age: '62',
      gender: 'male',
      backgroundDescription: 'David is the founder of Location Station, a news platform that aims to bring local news to the world. He is passionate about local events and wants to stay informed about the latest news and events in his area. He is also interested in cycling, hiking, story telling, theater, wine-tasting, and cooking.',
      conversationalInformality: 5,
    },
  }, 
  {
    id: 'benny-pollak',
    name: 'Benny Pollak',
    description: 'Location Station friend interesting in journalism and AI',
    endUserProfile: {
      name: 'Benny',
      interests: ['business', 'restaurants', 'arts', 'technology'],
      preferredContentTypes: ['business news', 'cultural events', 'technological innovations'],
      location: 'CA#San Francisco',
      age: '68',
      gender: 'male',
      backgroundDescription: 'Benny is a friend of Location Station and is a former professional programmer and active in the skeptic community.',
      conversationalInformality: 1,
    },
  }, 
  {
    id: 'simone-wilson',
    name: 'Simone Wilson',
    description: 'Journlist for The Healdsburg Newsletter',
    endUserProfile: {
      name: 'Simone',
      interests: ['business', 'restaurants', 'arts', 'culture', 'outdoors'],
      preferredContentTypes: ['cultural events', 'local news'],
      location: 'CA#Healdsburg',
      age: '34',
      gender: 'female',
      backgroundDescription: `Healdsburg, CA – Simone Wilson is a journalist and writer with deep roots in the Healdsburg community. Publicly available information indicates that she was born and raised in the city and her journalistic career began as the editor of the Healdsburg High School Hound's Bark.
Wilson's professional journey has taken her to various locations, including San Diego, Los Angeles, New York City, and the Middle East, where she worked as a local journalist. She has since returned to her hometown, contributing to several local publications.
Currently, Wilson is a staff member at Patch, covering news and events in and around Healdsburg. Her work for Patch includes a daily newsletter that keeps residents informed about important local happenings.
In addition to her role at Patch, Wilson has an extensive portfolio of work with other prominent local media outlets. She is a former senior product manager and staff writer for the Healdsburg Tribune and has also been a contributor to the North Bay Bohemian.
Beyond her work in journalism, Wilson is a published author. She has written several books focusing on the history and landscape of Sonoma County, with titles covering the Sonoma Coast, Petaluma, Santa Rosa, and the Russian River. Her writing in this area highlights her interest in the region's wildlife, communities, and environmental issues. Her author profiles note her passion for the outdoors, including hiking, kayaking, mushroom hunting, and birding along the 55-mile Sonoma Coast.`,
      conversationalInformality: 1,
    },
  },
  {
    id: 'lauren',
    name: 'Lauren Colella',
    description: 'Co-founder of Location Station interested in local news and community events',
    endUserProfile: {
      name: 'Lauren',
      interests: ['business', 'restaurants', 'arts', 'culture', 'outdoors', 'music'],
      preferredContentTypes: ['cultural events', 'local news'],
      location: 'CA#Coachella Valley',
      age: '34',
      gender: 'female',
      backgroundDescription: `Writer, researcher, and producer with a background in non-profit work. Experience working on psychology, wellness, and travel beats. Passionate about storytelling and community engagement.`,
      conversationalInformality: 1,
    },
  },
 
];

// Available interests and content types for dropdown options
export const availableInterests = [
  'arts', 'business', 'social justice', 'community affairs', 'education', 'environment', 
  'family events', 'food', 'health', 'local politics', 'parks', 
  'restaurants', 'schools', 'sports', 'technology', 'hiking / outdoors', 'outdoors', 'culture', 'music', 'theater', 'live events',
  'wine-tasting', 'cooking', 'cycling', 'story telling', 'local history', 'safety updates', 'cultural events'
  // Add more interests...
];

export const availableContentTypes = [
  'breaking news', 'business news', 'community events', 'cultural events', 'education news',
  'feature stories', 'health updates', 'local news', 'opinion pieces', 'political news',
  'safety updates', 'technological innovations'
  // Add more content types...
];